var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_335_26",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H30V30H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_335_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3633 9.25781H10.4102C9.6335 9.25781 9.00391 8.62822 9.00391 7.85156C9.00391 7.0749 9.6335 6.44531 10.4102 6.44531H19.5899C20.3665 6.44531 20.9961 7.0749 20.9961 7.85156C20.9961 8.62822 20.3665 9.25781 19.5899 9.25781H17.6367",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.59 9.25781L24.4986 16.9527C27.9396 22.3469 24.0652 29.4141 17.6669 29.4141H12.3334C5.93505 29.4141 2.06059 22.3469 5.50163 16.9527L10.4103 9.25781",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87891 1.09664C9.55414 0.421407 10.6489 0.421407 11.3241 1.09664L11.3284 1.10092C12.002 1.77445 13.0934 1.77639 13.7693 1.1052L13.7865 1.08809C14.4624 0.416895 15.5539 0.418829 16.2274 1.09236L16.2317 1.09664C16.907 1.77188 18.0017 1.77188 18.677 1.09664C19.3521 0.421407 20.4469 0.421407 21.1221 1.09664L19.5922 6.44531H10.4126L8.87891 1.09664Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6109 16.1649C16.6109 16.1649 15.5524 15.363 14.2809 15.745C12.983 16.1349 12.661 17.9114 13.5428 18.603C14.0491 19.0002 14.811 19.3267 15.8378 19.6896C18.1358 20.5019 17.2863 23.7428 14.9487 23.7584C14.0364 23.7644 13.61 23.7065 12.8086 23.1823",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.5312V24.9414",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.18783598f4e9be3e19818d7516803794.svg";
export { ForwardRef as ReactComponent };